import request from '@/utils/request'

let AuctionApi = {
  /*获取数据*/
  getData(data, errorback) {
    return request._get('/shop/plus.auction.auction/index', data, errorback);
  },

  /*用户拍卖列表*/
  getAuctionList(data, errorback) {
    return request._post('/shop/plus.auction.auction/index', data, errorback);
  },
  PurchaseList(data, errorback) {
    return request._post('/shop/plus.auction.auction/Purchase', data, errorback);
  },
  /*添加*/
  addAuction(data, errorback) {
    return request._post('/shop/plus.auction.auction/add', data, errorback);
  },

  /*获取拍卖信息*/
  auctionDetail(data, errorback) {
    return request._post('/shop/plus.auction.auction/AuctionDetail', data, errorback);
  },
  /*编辑*/
  editAuction(data, errorback) {
    return request._post('/shop/plus.auction.auction/edit', data, errorback);
  },
  // /*删除*/
  deleteAuction(data, errorback) {
    return request._post('/shop/plus.auction.auction/index', data, errorback);
  },
  // /*删除*/
  getAuction(data, errorback) {
    return request._get('/shop/setting.auction/index', data, errorback);
  },
  // /*删除*/
  setAuction(data, errorback) {
    return request._post('/shop/setting.auction/index', data, errorback);
  },
}
export default AuctionApi;



// WEBPACK FOOTER //
// ./src/api/auction.js